import { PermissionTypes } from 'features/permissions/types';
import { usePermissions } from 'features/permissions/usePermissions';
import { useFeatureFlag } from 'features/feature-set/useFeatureFlag';

export const useContentWhiteboard = () => {
  const isFeatureAvailable = useFeatureFlag('whiteboard');

  const { hasPermissions } = usePermissions();

  const canEditContent = hasPermissions(PermissionTypes.editWhiteboard);

  return {
    isFeatureAvailable,
    canEditContent,
  };
};
